// src/api/services/esupplyvet/diaporamasService.js
import esupplyvetApi from "@/api/esupplyvet";
import api from "@/api";
import { useRegisterStore } from "@/stores/register";

function getHttpClient() {
  const registerStore = useRegisterStore();
  const userRole = registerStore.user?.role || "";
  return userRole === "client" ? esupplyvetApi : api;
}

const E_SUPPLYVET_CHANNEL = "esupplyvet";

/**
 * Récupère tous les diaporamas depuis l'API
 * @returns {Promise} Réponse de l'API contenant tous les diaporamas
 */
export function getDiaporamas() {
  return getHttpClient().get("/diaporamas");
}

/**
 * Récupère les slides du channel e-supplyvet
 * @returns {Promise} Réponse de l'API contenant les slides filtrés
 */
export async function getESupplyVetSlides() {
  const response = await getDiaporamas();

  // Filtrer par channel esupplyvet et extraire les slides
  const esupplyvetDiaporama = response.data.find(diaporama => diaporama.channel.code === E_SUPPLYVET_CHANNEL);

  const slides = esupplyvetDiaporama?.slides || [];

  return {
    ...response,
    data: slides.filter(slide => slide.active),
  };
}
